import Navigation from './Navigation';
import useMonarchStore from '@/stores/monarchStore';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/* ============================================================================
   Sidebar Component — Warm luxury navigation
   ============================================================================ */

export default function Sidebar() {
  const sidebarCollapsed = useMonarchStore((s) => s.ui.sidebarCollapsed);
  const activeSection = useMonarchStore((s) => s.ui.activeSection);
  const setActiveSection = useMonarchStore((s) => s.setActiveSection);
  const toggleSidebar = useMonarchStore((s) => s.toggleSidebar);
  const mobileMenuOpen = useMonarchStore((s) => s.ui.mobileMenuOpen);
  const setMobileMenuOpen = useMonarchStore((s) => s.setMobileMenuOpen);

  return (
    <>
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      <aside
        className={`
          fixed top-16 left-0 bottom-0 z-50
          bg-bg-1 border-r border-border
          flex flex-col
          transition-all duration-300 ease-out
          ${sidebarCollapsed ? 'w-16' : 'w-64'}
          max-md:${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        {/* Brand area */}
        <div className={`
          flex items-center justify-center
          h-14 border-b border-border
          ${sidebarCollapsed ? 'px-2' : 'px-4'}
        `}>
          <img
            src="/logos/monarch-logo.avif"
            alt="The Monarch"
            className={`logo-theme-aware ${sidebarCollapsed ? 'h-8 w-auto object-contain' : 'h-10 w-auto object-contain'}`}
          />
          {!sidebarCollapsed && (
            <span className="ml-3 font-display text-sm text-text-2 tracking-wide">
              The Monarch
            </span>
          )}
        </div>

        {/* Navigation links */}
        <div className="flex-1 py-6 px-2 overflow-y-auto scrollbar-thin">
          <Navigation
            activeSection={activeSection}
            onNavigate={setActiveSection}
            collapsed={sidebarCollapsed}
          />
        </div>

        <div className="h-px bg-border" />

        {/* Footer with collapse toggle */}
        <div className={`
          p-3 border-t border-border
          ${sidebarCollapsed ? 'flex justify-center' : 'flex items-center justify-between'}
        `}>
          {!sidebarCollapsed && (
            <span className="text-[10px] text-text-3 uppercase tracking-widest">
              Curio Collection
            </span>
          )}
          <button
            onClick={toggleSidebar}
            className="p-1.5 rounded-md bg-bg-2 border border-border text-text-3 hover:text-text hover:border-border-2 transition-colors"
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed ? (
              <ChevronRight className="w-4 h-4" />
            ) : (
              <ChevronLeft className="w-4 h-4" />
            )}
          </button>
        </div>
      </aside>
    </>
  );
}
